import React from 'react';
import type { ModalBodyVariant } from './type';
import { Overlay, Content } from './view';

interface Props {
    children: React.ReactNode;
    name: string;
    onClick?: () => void;
    variant?: ModalBodyVariant;
    width?: string;
    zIndex?: string;
    overlayZIndex?: string;
    overlayBackground?: string;
    isNeedOverlay?: boolean;
}

const ModalOverlay = (props: Props) => {
    const {
        children,
        onClick,
        variant = 'default',
        name,
        width,
        zIndex,
        overlayZIndex,
        overlayBackground,
        isNeedOverlay = true,
    } = props;
    const checkIsTransparent = (): boolean => !['media-preview', 'attachment-preview'].includes(name);

    return (
        <>
            {isNeedOverlay && (
                <Overlay
                    onClick={onClick}
                    isTransparent={checkIsTransparent()}
                    zIndex={overlayZIndex}
                    background={overlayBackground}
                />
            )}
            <Content
                variant={variant}
                width={width}
                zIndex={zIndex}
            >
                {children}
            </Content>
        </>
    );
};

export default ModalOverlay;
